import { Link, Message } from '@bedrock/components';
import { ProText } from '@bedrock/eed-react';
import { EllipsisTooltip } from '@mpc/components';
import React from 'react';
import { FC } from 'react';
import { ProInputProps } from '@bedrock/eed-react';

export const ProTextPercentage: FC<Partial<ProInputProps>> = (props) => {
  const render = (value: any) => {
    if (!value) return '-';
    return `${value}`;
  };
  return <ProText {...props} render={render} />;
};
